import type { LucideIcon, LucideProps } from "lucide-react";

import React from "react";

// Create the icon using the same pattern as lucide-react
const ABTesting: LucideIcon = React.forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      color = "currentColor",
      size = 24,
      strokeWidth = 2,
      className = "",
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={color}
        className={className}
        {...props}
      >
        <path
          d="M18 6L6 18"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 9L5.5 2L9 9M2.875 7.25H8.125"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 17.5H20.1538C20.6435 17.5 21.1131 17.6844 21.4593 18.0126C21.8055 18.3408 22 18.7859 22 19.25C22 19.7141 21.8055 20.1592 21.4593 20.4874C21.1131 20.8156 20.6435 21 20.1538 21H16V14H19.6923C20.1819 14 20.6515 14.1844 20.9977 14.5126C21.344 14.8408 21.5385 15.2859 21.5385 15.75C21.5385 16.2141 21.344 16.6592 20.9977 16.9874C20.6515 17.3156 20.1819 17.5 19.6923 17.5"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

// Add display name for React DevTools
ABTesting.displayName = "ABTesting"; // Renamed component

export default ABTesting; // Export renamed component
